import { Colors } from 'assets/colors';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  flex: 1;
  min-width: 0;

  @media (max-width: 1350px) {
    flex: none;
    width: 100%;
  }

  /* Card container */
  background: #ffffff;
  border: 1px solid #e1e5ec;
  border-radius: 12px;
  padding: 20px;
  height: 100%;

  .top-merchant {
    &-box {
      margin-top: 0;
    }

    &-top {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;
    }

    &-title {
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      color: #1a1f36;
    }
  }

  .table-wrapper {
    width: 100%;
    border: 1px solid #e1e5ec;
    border-radius: 8px;
    height: 248px;
    overflow-y: auto;
  }

  table {
    width: 100%;

    th {
      font-weight: 600;
      font-size: 11px;
      line-height: 16px;
      color: #131b1f;
      padding: 12px 14px;
      text-transform: uppercase;
    }

    td {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #3c4257;
      padding: 12px 14px;
    }

    tr {
      border-top: 1px solid #e1e5ec;
    }
  }

  .strong {
    color: #1a1f36;
    font-weight: 600;
  }

  .ellipsis {
    text-overflow: ellipsis;
    height: 16px;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
  }

  .no-item {
    padding: 40px 20px;
    text-align: center;
  }
`;
